
import { useKimLhc } from '@/context/KimLhc';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useStepMutation } from '@/components/views/Report/KimLhc/hooks/useStepMutation';
import { FormFields } from '@/components/views/Report/KimLhc/types';

interface WorkConditionParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	work_condition_hands_position?: string | null;
	work_condition_transfer?: string | null;
	work_condition_spatial_condition?: string | null;
	work_condition_adverse?: string | null;
	work_condition_clothes?: string | null;
	work_condition_hold_load?: string | null;
}

export function useWorkCondition() {
	const { organization, company } = useApplicationContext();
	const { file_id, report_id } = useKimLhc();
	const { mutate, isLoading: isLoadingStepMutation } = useStepMutation<WorkConditionParams>();

	function buildUpdatePayload(values: FormFields): WorkConditionParams | null {
		if (!report_id || !file_id) {
			return null;
		}

		const workConditionData = values.work_condition;

		return {
			id: report_id,
			file_id: file_id,
			company_id: company.id,
			organization_id: organization.id,
			work_condition_hands_position: workConditionData?.work_condition_hands_position ?? null,
			work_condition_transfer: workConditionData?.work_condition_transfer ?? null,
			work_condition_spatial_condition: workConditionData?.work_condition_spatial_condition ?? null,
			work_condition_adverse: workConditionData?.work_condition_adverse ?? null,
			work_condition_clothes: workConditionData?.work_condition_clothes ?? null,
			work_condition_hold_load: workConditionData?.work_condition_hold_load ?? null
		};
	}


	async function handleSubmit(values: FormFields): Promise<void> {
		const payload = buildUpdatePayload(values);

		if (!payload) {
			return;
		}

		await mutate(payload);
	}

	const isLoading = isLoadingStepMutation;

	return {
		handleSubmit,
		isLoading
	};
}
